module.exports = __webpack_public_path__ + "static/media/roles.2aa3658b.png";